module.exports = __webpack_public_path__ + "static/media/MIDI.08b7e796.svg";